import React, { useState, useEffect } from 'react';
import style from '../css/Livechat.module.css';
import { FaMessage, FaWhatsapp, FaX } from 'react-icons/fa6';
import { FaArrowAltCircleRight, FaHome, FaPhoneAlt } from 'react-icons/fa';
import { Link } from 'react-router-dom';
import HeaderBar from './HeaderBar';

function LiveChat() {
	const [open, setOpen] = useState(false);
	const [guestId, setGuestId] = useState(null);
	const [messages, setMessages] = useState([]);
	const [message, setMessage] = useState('');

	// ✅ Fetch or generate Guest ID
	useEffect(() => {
		let storedGuestId = localStorage.getItem('guest_id');
		if (storedGuestId) {
			setGuestId(storedGuestId);
			fetchMessages(storedGuestId);
		} else {
			fetch('https://hometech-repairs.in/homeTech/generate_guest_id.php')
				.then((res) => res.json())
				.then((data) => {
					if (data.guest_id) {
						setGuestId(data.guest_id);
						localStorage.setItem('guest_id', data.guest_id);
					}
				})
				.catch((error) => console.error('Guest ID Error:', error));
		}
	}, []);

	// ✅ Fetch messages for this Guest ID
	const fetchMessages = (id) => {
		fetch(
			`https://hometech-repairs.in/homeTech/get_messages.php?guest_id=${id}`
		)
			.then((res) => res.json())
			.then((data) => {
				console.log('Fetched Messages:', data); // Debugging
				if (data.messages) {
					setMessages(data.messages); // ✅ Correctly updating messages
				} else {
					console.error('No messages found:', data);
				}
			})
			.catch((error) => console.error('Message Fetch Error:', error));
	};

	// ✅ Auto-refresh messages every 2 sec
	useEffect(() => {
		if (guestId) {
			const interval = setInterval(() => fetchMessages(guestId), 2000);
			return () => clearInterval(interval);
		}
	}, [guestId]);

	// ✅ Send message function
	const sendMessage = () => {
		if (!message.trim()) return;

		const newMessage = { guest_id: guestId, sender: 'guest', message };

		fetch('https://hometech-repairs.in/homeTech/save_message.php', {
			method: 'POST',
			headers: { 'Content-Type': 'application/json' },
			body: JSON.stringify(newMessage),
		})
			.then((res) => res.text()) // Read the response as text first
			.then((text) => {
				console.log('Response Text:', text); // Log the raw response
				try {
					const data = JSON.parse(text); // Now parse the text as JSON
					if (data.success) {
						setMessage('');
						fetchMessages(guestId); // Fetch messages immediately after sending
					} else {
						console.error('Error saving message:', data.error);
						alert('Error: ' + data.error);
					}
				} catch (error) {
					console.error('Message Send Error:', error);
					alert('Failed to parse response as JSON. Check console.');
				}
			})
			.catch((error) => {
				console.error('Message Send Error:', error);
				alert('Failed to send message. Check console.');
			});
	};

	return (
		<div>
			<HeaderBar
				text={'Support'}
				icon={<FaHome color="black" size={20} />}
				navi="/dashboard"
			/>

			<div className={style.body}>
				<div className={style.chatBox}>
					{messages.length === 0 ? (
						<div>
							<p>This space is waiting for your words ✨</p>
							<strong>Live Chat '9AM-6PM'</strong>

							<div className={style.btnGroup}>
								<Link to={'tel:+919036874408'} className={style.btn}>
									<FaPhoneAlt size={20} color="black" />
								</Link>

								<Link to={'https://wa.me/919036874408'} className={style.btn}>
									<FaWhatsapp size={20} color="black" />
								</Link>
							</div>
						</div>
					) : (
						messages.map((msg, index) => (
							<div
								key={index}
								style={{
									textAlign: msg.sender === 'guest' ? 'right' : 'left',
								}}
							>
								<span
									style={{
										background: msg.sender === 'guest' ? 'green' : '#ffffff',
										padding: '5px',
										borderRadius: '5px',
										display: 'inline-block',
										margin: '5px',

										color: msg.sender === 'guest' ? 'white' : 'black',
									}}
								>
									{msg.message}
									<br />
									<span className={style.date}>
										{(() => {
											const date = new Date(msg.created_at);
											const day = String(date.getDate()).padStart(2, '0');
											const month = String(date.getMonth() + 1).padStart(
												2,
												'0'
											);
											const year = date.getFullYear();
											return `${day}-${month}-${year}`;
										})()}
									</span>
								</span>
							</div>
						))
					)}
				</div>

				<div className={style.inputDiv}>
					<input
						type="text"
						placeholder="Type your message..."
						className={style.input}
						value={message}
						onChange={(e) => setMessage(e.target.value)}
						onKeyDown={(e) => e.key === 'Enter' && sendMessage()}
					/>
					<div onClick={sendMessage}>
						<FaArrowAltCircleRight size={20} />
					</div>
				</div>
			</div>
			<div style={{ textAlign: 'center', marginTop: '20px' }}>
				<p>
					© 2025 HomeTech Repairs. <br /> All rights reserved.
				</p>
			</div>
		</div>
	);
}

export default LiveChat;
